import React from "react";
import Color from "../../../../../utils/Color";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import RowSection from "../../../../components/RowSection";
import ExpandMoreRoundedIcon from "@material-ui/icons/ExpandMoreRounded";
import ExpandLessRoundedIcon from "@material-ui/icons/ExpandLessRounded";

const CommonQuestions = ({
  openQ1,
  onClickQ1,
  onClickOnlineAccount,
  onClickGiroLink,
  onClickQ2,
  openQ2,
  openQ3,
  onClickQ3,
  openQ4,
  onClickQ4,
  openQ5,
  onClickQ5,
  openQ6,
  onClickQ6,
  onClickGiroLinkV2,
  onClickHere
}) => {
  const classes = useStyles();
  return (
    <Grid container direction={"column"} spacing={2}>
      <Grid item>
        <RowSection
          title={"Quick Renewal on Etiqa or Tiq websites"}
          icon={
            openQ1 ? (
              <ExpandLessRoundedIcon style={{ fill: "#2c3034" }} />
            ) : (
              <ExpandMoreRoundedIcon style={{ fill: "#2c3034" }} />
            )
          }
          onClickRowSection={onClickQ1}
        />
        {openQ1 ? (
          <CustomText design={classes.descTextStyle} component="div">
            This is the quickest and easiest way to renew. Once you have
            completed the payment process, you will receive an email or SMS
            notification from us to inform you that your renewal request will be
            processed within 3 to 5 working days. To check details of your newly
            renewed policy, please login to your{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={onClickOnlineAccount}
            >
              Online Account
            </CustomText>
            .
          </CustomText>
        ) : (
          false
        )}
      </Grid>

      <Grid item>
        <RowSection
          title={"What are the other payment methods for renewal?"}
          icon={
            openQ2 ? (
              <ExpandLessRoundedIcon style={{ fill: "#2c3034" }} />
            ) : (
              <ExpandMoreRoundedIcon style={{ fill: "#2c3034" }} />
            )
          }
          onClickRowSection={onClickQ2}
        />
        {openQ2 ? (
          <div>
            <div style={{ marginBottom: 5 }}>
              <CustomText design={classes.titleDescTextStyle}>
                1. BY YOUR ONLINE ACCOUNT
              </CustomText>

              <CustomText design={classes.q2TextStyle}>
                Use your eWallet credits to offset your policy renewal premium
                amount. Login to your Online Account account here.
              </CustomText>
            </div>

            <div style={{ marginBottom: 5 }}>
              <CustomText design={classes.titleDescTextStyle}>
                2. By INTERNET BANKING (for Maybank and DBS Customers only)
              </CustomText>

              <CustomText design={classes.q2TextStyle}>
                When making payment via internet banking, please enter your
                policy number in the Reference section. Policy number and
                premium amount can be found in your renewal notice.
              </CustomText>
            </div>

            <div style={{ marginBottom: 5 }}>
              <CustomText design={classes.titleDescTextStyle}>
                3. BY PAYNOW QR
              </CustomText>

              <CustomText design={classes.q2TextStyle} component="div">
                You can make payment via the PayNow QR code which can be found in your renewal notice. PayNow is supported by these Participating Banks: Bank of China, Citibank, DBS/POSB, HSBC Bank, Industrial and Commercial Bank of China Limited, Maybank, OCBC Bank, Standard Chartered Bank & United Overseas Bank Limited.
              </CustomText>
              <br />
              <CustomText design={classes.q2TextStyle} component="div">
                Please click <CustomText
                  display={"inline"}
                  design={classes.highLightedTextStyle}
                  onClick={onClickHere}
                >
                  here
                </CustomText> to renew your HDB Fire Insurance.
              </CustomText>
            </div>

            {/* <div style={{ marginBottom: 5 }}>
              <CustomText design={classes.titleDescTextStyle}>
                4. BY GIRO
              </CustomText>

              <CustomText design={classes.q2TextStyle} component="div">
                Please click on the{" "}
                <CustomText
                  display={"inline"}
                  design={classes.highLightedTextStyle}
                  onClick={onClickGiroLinkV2}
                >
                  link
                </CustomText>{" "}
                to download the GIRO form and <CustomText
                  display={"inline"}
                  design={classes.highLightedTextStyle}
                  onClick={onClickGiroLink}
                >
                  Business Envelope Form.
                </CustomText>
              </CustomText>
            </div> */}

            {/* <div style={{ marginBottom: 5 }}>
              <CustomText design={classes.titleDescTextStyle}>
                5. BY CASH OR NETS AT ETIQA CUSTOMER CARE CENTRE
              </CustomText>

              <CustomText design={classes.q2TextStyle}>
                You can pay cash or NETS at our Customer Care Centre located at:
                One Raffles Quay, #22-01 North Tower, Singapore 048583
                (Monday – Friday, 8:45am – 5:30pm, excluding Public Holidays).
              </CustomText>
            </div> */}

            {/* <div style={{ marginBottom: 5 }}>
              <CustomText design={classes.titleDescTextStyle}>
                6. BY CHEQUE
              </CustomText>

              <CustomText design={classes.q2TextStyle}>
                Payment by Cheque is accepted and should be crossed and made
                payable to Etiqa Insurance Pte. Ltd.
              </CustomText>
            </div> */}
          </div>
        ) : (
          false
        )}
      </Grid>

      <Grid item>
        <RowSection
          title={"How do I find my policy number?"}
          icon={
            openQ3 ? (
              <ExpandLessRoundedIcon style={{ fill: "#2c3034" }} />
            ) : (
              <ExpandMoreRoundedIcon style={{ fill: "#2c3034" }} />
            )
          }
          onClickRowSection={onClickQ3}
        />
        {openQ3 ? (
          <CustomText design={classes.descTextStyle}>
            Your insurance policy number can be found on your policy documents
            or any renewal notice you received from us via letter, email or SMS.
          </CustomText>
        ) : (
          false
        )}
      </Grid>

      <Grid item>
        <RowSection
          title={"How do I change my policy details?"}
          icon={
            openQ4 ? (
              <ExpandLessRoundedIcon style={{ fill: "#2c3034" }} />
            ) : (
              <ExpandMoreRoundedIcon style={{ fill: "#2c3034" }} />
            )
          }
          onClickRowSection={onClickQ4}
        />
        {openQ4 ? (
          <CustomText design={classes.descTextStyle} component="div">
            If you wish to make changes to your policy, you may login to your{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={onClickOnlineAccount}
            >
              Online Account
            </CustomText>{" "}
            to raise a request or WhatsApp our Customer Care Team at +65 6887
            8777.
          </CustomText>
        ) : (
          false
        )}
      </Grid>

      <Grid item>
        <RowSection
          title={
            "I have a renewal discount stated in the renewal notice. How do I enjoy it when renewing online?"
          }
          icon={
            openQ5 ? (
              <ExpandLessRoundedIcon style={{ fill: "#2c3034" }} />
            ) : (
              <ExpandMoreRoundedIcon style={{ fill: "#2c3034" }} />
            )
          }
          onClickRowSection={onClickQ5}
        />
        {openQ5 ? (
          <CustomText design={classes.descTextStyle}>
            When doing a renewal on our website, your entitled discount will be
            automatically reflected at the final payable amount.
          </CustomText>
        ) : (
          false
        )}
      </Grid>

      <Grid item>
        <RowSection
          title={
            "I am not interested in renewing my policy. Do I need you to notify you on cancelling my policy?"
          }
          icon={
            openQ6 ? (
              <ExpandLessRoundedIcon style={{ fill: "#2c3034" }} />
            ) : (
              <ExpandMoreRoundedIcon style={{ fill: "#2c3034" }} />
            )
          }
          onClickRowSection={onClickQ6}
        />
        {openQ6 ? (
          <CustomText design={classes.descTextStyle} component="div">
            Yes, if you are on a GIRO arrangement to make premium payments.
            Please login to your{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={onClickOnlineAccount}
            >
              Online Account{" "}
            </CustomText>
            to raise a request or email us at{" "}
            <CustomText
              display={"inline"}
              design={classes.highLightedTextStyle}
              onClick={onClickOnlineAccount}
            >
              customer.service@etiqa.com.sg
            </CustomText>{" "}
            within 14 days before the premium payment due date, or your policy
            will be renewed automatically. Kindly include information such as
            your policy number, name, contact number and email address.
          </CustomText>
        ) : (
          false
        )}
      </Grid>
    </Grid>
  );
};

const useStyles = makeStyles((theme) => ({
  highLightedTextStyle: {
    color: "#2C3034",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    textDecoration: "underline",
    "&:hover": {
      cursor: "pointer",
    },
  },
  descTextStyle: {
    color: "#2C3034",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("600"),
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    lineHeight: 1.4,
    textAlign: "justify",
  },
  titleDescTextStyle: {
    color: "#2C3034",
    fontFamily: "Muli",
    ...getFontSize("small"),
    ...getFontWeight("bold"),
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    paddingBottom: 10,
  },
  q2TextStyle: {
    color: "#2C3034",
    fontFamily: "Muli",
    ...getFontSize("small"),
    paddingLeft: 30,
    paddingRight: 30,
    textAlign: "justify",
  },
}));

export default CommonQuestions;
